import React from "react";
import { Content, Section, TextDiv } from "../styles/Common";
import { styled } from "styled-components";
import OnlyHeaderLayout from "../components/layout/OnlyHeaderLayout";
import OnePageLayout from "../components/layout/OnePageLayout";
import { useLocation } from "react-router-dom";

const IntroducePartnersDetailPage = () => {
  const location = useLocation();
  const target = location.state.target;
  function replaceNewlineWithBreak(input) {
    const replacedString = input.includes("\n")
      ? input.replace(/\n/g, `</br>`)
      : input;
    return <div dangerouslySetInnerHTML={{ __html: replacedString }} />;
  }
  return (
    <OnePageLayout title="제휴사 소개">
      <Section className="minPaddingTop">
        <Content>
          <IntroduceWrap>
            <LogoWrap>
              <img src={target.image} alt="" />
            </LogoWrap>
            <IntroduceTextDiv>
              <h4>{target.name}</h4>
              <ul>
                <li>
                  <label htmlFor="">설명</label>
                  <p className="description">{target?.description || ""}</p>
                  {/* <input
                    type="text"
                    value={target?.description || ""}
                    disabled
                    readOnly
                  /> */}
                </li>

                <li>
                  <label htmlFor="">홈페이지</label>

                  {/* <input
                    type="text"
                    readOnly
                    disabled
                    className="none-cursor pointer"
                    value={target.homepage || ""}
                    onChange={() => {
                      return;
                    }}
                    onClick={() => {
                      window.open(target.homepage);
                    }}
                  /> */}
                  <span
                    className="none-cursor pointer"
                    onClick={() => {
                      window.open(target.homepage);
                    }}
                  >
                    {target.homepage || ""}
                  </span>
                </li>
              </ul>
              <Disc>{replaceNewlineWithBreak(target.description2)}</Disc>
            </IntroduceTextDiv>
          </IntroduceWrap>
        </Content>
      </Section>
    </OnePageLayout>
  );
};

export default IntroducePartnersDetailPage;

const IntroduceWrap = styled.div`
  padding: 0 1rem 1rem 1rem;
`;

const IntroduceTextDiv = styled(TextDiv)`
  margin-top: 5rem;
  text-align: left;
  h4 {
    font-family: NanumSquareEB;
    font-size: 1.6rem;
    font-weight: 800;
    line-height: 2rem; /* 125% */
    letter-spacing: -0.48px;
  }
  ul {
    padding: 2rem 0 3rem 0;

    li {
      margin-top: 1rem;
      display: flex;
    }
  }
  label {
    display: inline-block;
    width: 7.8rem;
    color: ${({ theme }) => theme.color.black};
    font-size: 1.4rem;
    font-style: normal;
    font-weight: 700;
    line-height: 2rem; /* 142.857% */
    letter-spacing: -0.42px;
  }
  input,
  .description,
  span {
    color: ${({ theme }) => theme.color.purple_primary};
    width: calc(100% - 7.8rem);
    font-size: 1.4rem;
    font-style: normal;
    font-weight: 400;
    line-height: 2rem; /* 142.857% */
    letter-spacing: -0.42px;
    background-color: transparent;
    font-family: NanumSquareR;
    position: relative;
  }
  .none-cursor {
    :focus,
    :active {
      outline: none;
    }
    caret-color: transparent;
    outline: none;
  }
`;
const Disc = styled.div`
  border-bottom: 1px dashed #919191;
  border-top: 1px dashed #919191;
  padding: 1.5rem 0;
  color: ${({ theme }) => theme.color.purple_primary};
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px; /* 142.857% */
  letter-spacing: -0.42px;
`;
const LogoWrap = styled.div`
  width: 100%;
  min-height: 10.7rem;
  border-radius: 10px;
  background: ${({ theme }) => theme.color.white};
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  img {
    max-width: 70%;
    max-height: 100%;
  }
`;
